import type { RouteLocationRaw } from "vue-router";

export function getProductRoute(productId: string, productSlug?: string): RouteLocationRaw;
export function getProductRoute(productId?: string, productSlug?: string): RouteLocationRaw | undefined {
  const defaultRoute = productId ? { name: "Product", params: { productId } } : undefined;
  return productSlug ? `/${productSlug}` : defaultRoute;
}

/**
 * The single canonical path for a product, matching what getProductRoute links to:
 * the SEO slug when the category chain resolves, otherwise the /product/{id} fallback.
 * Used for the canonical tag, og:url and JSON-LD so they cannot drift apart.
 */
export function getProductCanonicalPath(productId?: string, productSlug?: string): string | undefined {
  if (productSlug) {
    return `/${productSlug}`;
  }
  return productId ? `/product/${productId}` : undefined;
}
